import $ from 'jquery';
import {toCamelCase} from './strings';
/**
 * Generate a jQuery plugin
 * @param pluginName [string] Plugin name
 * @param className [object] Class of the plugin
 * @param shortHand [bool] Generate a shorthand as $.pluginName
 *
 * @example
 * import plugin from 'plugin';
 *
 * class MyPlugin {
 *     constructor(element, options) {
 *         // ...
 *     }
 * }
 *
 * or
 *
 * function MyPlugin (element, options) {
 *   assert(options.something, true);
 * }
 *
 * then
 *
 * MyPlugin.DEFAULTS = {
 *   something: false
 * };
 *
 * plugin('myPlugin', MyPlugin);
 *
 * $(() => {
 *   $('[data-my-plugin]').myPlugin();
 * })
 *
 * <div data-my-plugin data-my-plugin-something="true"></div>
 */
export default function plugin(pluginName, className, shortHand = false) {
    const dataName = `__${pluginName}`;
    const old = $.fn[pluginName];
    const ZERO = 0;

    className.$bus = {
        subscribe: function(event, fn) {
            $(this).bind(event, fn);
        },
        publish: function(event, data) {
            $(this).trigger(event, [data]);
        }
    };

    $.fn[pluginName] = function PluginFactory (option) {
        return this.each(function PluginInstanceFactory () {
            const $this = $(this);
            const overrides = typeof option === 'object' && option;
            const elementOptions = Object
                .keys($this.data())
                .map((key) => toCamelCase(key))
                .filter((key) => key.indexOf(pluginName) >= ZERO)
                .reduce((result, source) => {
                    const key = toCamelCase(source.replace(pluginName, ''));
                    result[key] = $this.data(source);

                return result;
            }, {});

            let instance = $this.data(dataName);
            const options = $.extend({}, className.DEFAULTS, elementOptions, overrides);

            // store reference to instance
            if (!instance) {
                $this.data(dataName, instance = new className(this, options));
            }

            // execute instance method
            if (typeof option === 'string') {
                instance[option]();
            }
        });
    };

    // - Short hand
    if (shortHand) {
        $[pluginName] = (options) => $({})[pluginName](options);
    }

    // - No conflict
    $.fn[pluginName].noConflict = function noConflict () {
        $.fn[pluginName] = old;
    };
}

export function jquery (name) {
    return function decroate (target) {
        plugin(name, target);
    };
}

export function defaults (options) {
    return function decorate (target) {
        target.DEFAULTS = options;
    };
}



// WEBPACK FOOTER //
// ./client/src/core/lib/plugin.js